import { render, staticRenderFns } from "./LoadingUpdateAvatar.vue?vue&type=template&id=3a77edab"
import script from "./LoadingUpdateAvatar.vue?vue&type=script&lang=js"
export * from "./LoadingUpdateAvatar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports